export default {
  zh: {
    passwordPlaceholder: '密码',
    emailPlaceholder: '邮箱',
    loginText: '登录',
    failedRequest: '网络错误',
    forgotPassword: '忘记密码？',
    signUp: '注册'
  },
  en: {
    passwordPlaceholder: 'Password',
    emailPlaceholder: 'Email',
    loginText: 'Sign In',
    failedRequest: 'Network error, please try again later',
    forgotPassword: 'Forget Password?',
    signUp: 'Register'
  }
}



// WEBPACK FOOTER //
// ./src/components/loginform/emailLogin/lang.js